/**
 * Service de integracoes (ADR-0035 — Marketplace).
 *
 * Endpoint /api/integracoes retorna catalogo de integracoes disponiveis
 * agrupadas por dominio. Read-only — config de cada integracao fica na
 * tela proprietaria do dominio.
 */

const PREFIXO = "/api/integracoes";


export function listarIntegracoes(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.dominio) usp.set("dominio", params.dominio);
  if (params.status) usp.set("status", params.status);
  const qs = usp.toString();
  return request(`${PREFIXO}/${qs ? `?${qs}` : ""}`);
}


// Status helper — mapa visivel pra UI
export const STATUS_LABEL = {
  ATIVA: "Ativa",
  DISPONIVEL: "Disponível",
  PLACEHOLDER: "Planejada",
  EM_DESENVOLVIMENTO: "Em desenvolvimento",
};
